import React from "react";
import AndroidService from "../../Services/AndroidService";
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { WhatsappShareButton } from "react-share";
import StringUtils from "../../Utils/StringUtils";
import useMessages from "../../Hooks/useMessages";
import AnalyticsService from "../../Services/AnalyticsService";
import config from "../../config";

const useStyles = makeStyles(() => ({
  shareButton: {
    textTransform: "uppercase",
    borderRadius: "0px",
    position: "fixed",
    bottom: 0,
    zIndex: 4,
    minHeight: "50px",
    maxHeight: "50px",
    maxWidth: "600px",
    background: "#00733E !important",
    width: "100%",
    color: "white !important",
    gap: "4px",
  },
}));

const ShareOrderApprovalLinkButton = ({ order, page }) => {
  const classes = useStyles();
  const { getMessage } = useMessages();
  const shareUrl =
    page === "orderDetails"
      ? `${config?.appUrl}/orders/${order?.orderId}`
      : `${config?.appUrl}/orders/${order?.placedOrders?.[0]?.orderId}`;

  const orderValue =
    page === "orderDetails" ? order?.payableAmount : order?.totalValue;

  const orderApprovalShareMessage = (order) => {
    return StringUtils.fillTemplate(
      getMessage("orderDetails.shareApprovalLink"),
      [orderValue]
    );
  };

  const handleButtonClicked = () => {
    AnalyticsService.pushEvent("Button Clicked", {
      type: "Share Approval Link",
      page: "Order Detail",
      orderId:
        page === "orderDetails"
          ? order?.orderId
          : order?.placedOrders?.[0]?.orderId,
    });
    AndroidService.shareOnWhatsApp(
      `${orderApprovalShareMessage(order)} ${shareUrl}`
    );
  };
  return (
    <>
      {AndroidService.checkIfAndroid() ? (
        <Button
          fullWidth
          color={"secondary"}
          variant={`contained`}
          size={`large`}
          disableRipple
          disableTouchRipple
          endIcon={<img src={`/icons/share.svg`} alt="" />}
          sx={{
            textTransform: "uppercase",
            borderRadius: "0px",
            position: "fixed",
            bottom: 0,
            zIndex: 4,
            minHeight: "50px",
            maxHeight: "50px",
            maxWidth: "600px",
          }}
          onClick={handleButtonClicked}
        >
          Share Approval Link To Partner
        </Button>
      ) : (
        <WhatsappShareButton
          className={classes.shareButton}
          url={shareUrl}
          title={orderApprovalShareMessage(order)}
          onClick={handleButtonClicked}
        >
          <span
            style={{
              fontSize: "15px",
              marginRight: "8px",
              verticalAlign: "middle",
            }}
          >
            Share Approval Link To Partner
          </span>
          <img
            src={`/icons/share.svg`}
            alt=""
            style={{ verticalAlign: "middle" }}
          />
        </WhatsappShareButton>
      )}
    </>
  );
};

export default ShareOrderApprovalLinkButton;
